import { CenteredSpinner } from '../CenteredSpinner';
import { FloatingContainer, Screen } from '../Container';

export const CardSpinner = () => (
  <Screen data-testid="screen">
    <FloatingContainer borderRadius={0} data-testid="floating-container" height="100%">
      <CenteredSpinner />
    </FloatingContainer>
  </Screen>
);
